import { HotelInfoModel } from '@/__generated';
import HotelLocationSearchLink from '@/components/App/HotelLocationSearchLink';
import { LocationType } from '@/constants';
import { AppUrls } from '@/urls';
import React from 'react';
import { Link } from 'react-router-dom';

type Props = { hotelInfo: HotelInfoModel };

export default function HotelDetailBreadCrumb({ hotelInfo }: Props) {
  return (
    <section className="py-10 d-flex items-center bg-light-2">
      <div className="container">
        <div className="row y-gap-10 items-center justify-between">
          <div className="col-auto">
            <div className="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
              <Link to={AppUrls.HomePage} className="col-auto">
                <i className="icon-home text-14 mr-5" />
                Home
              </Link>
              <div className="col-auto">&gt;</div>
              {hotelInfo.prefectureCode ? (
                <>
                  <HotelLocationSearchLink locationCode={hotelInfo.prefectureCode || ''} locationType={LocationType.Prefecture} className="col-auto">
                    {hotelInfo.prefectureName}
                  </HotelLocationSearchLink>

                  <div className="col-auto">&gt;</div>
                </>
              ) : null}
              {hotelInfo.areaCode ? (
                <>
                  <HotelLocationSearchLink locationCode={hotelInfo.areaCode || ''} locationType={LocationType.Area} className="col-auto">
                    {hotelInfo.areaName}
                  </HotelLocationSearchLink>
                  <div className="col-auto">&gt;</div>
                </>
              ) : null}
              {hotelInfo.cityCode ? (
                <>
                  <HotelLocationSearchLink locationCode={hotelInfo.cityCode || ''} locationType={LocationType.City} className="col-auto">
                    {hotelInfo.cityName}
                  </HotelLocationSearchLink>
                  <div className="col-auto">&gt;</div>
                </>
              ) : null}

              <div className="col-auto">
                <div className="text-dark-1 fw-500">{hotelInfo.nameEn}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
